import {
  Button,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { url } from "../../baseUrl";
import { useSelector } from "react-redux";
import axios from "axios";
import CustomizedSnackbars from "../../Components/SnackBar/SnackBar";
import Navbar from "../../Components/Navbar/Navbar";

// ─── E‑ComSnaps Brand Colors ───────────────────────────────
const brand = {
  primary: "#0006df",
  primaryDark: "#0a0fca",
  white: "#ffffff",
  lightGray: "#f8fafc",
  border: "#e2e8f0",
  gradient: "linear-gradient(180deg, #0a0fca 0%, #ffffff 100%)",
  textPrimary: "#1e293b",
};

// ─── USA TIME HELPER FUNCTIONS ──────────────────────────────
const getUSADateTime = () => {
  return new Date().toLocaleString('en-US', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  });
};

const getUSAMonth = () => {
  return new Date().toLocaleString('en-US', {
    timeZone: 'America/New_York',
    month: 'long',
  });
};

const getUSAYear = () => {
  return new Date().toLocaleString('en-US', {
    timeZone: 'America/New_York',
    year: 'numeric',
  });
};

const TransactionForm = () => {
  let { id } = useParams();
  let param = id.split("_");
  const state = useSelector((state) => state.user.data);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState(0);
  const [brandName, setBrandName] = useState("ecomsnaps");
  const [orderId, setOrderId] = useState("");
  const [typeOfSale, setTypeOfSale] = useState("");
  const [salesPerson, setSalesPerson] = useState("");
  const [amount, setAmount] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [additionalCharges, setAdditionalCharges] = useState(0);
  const [total, setTotal] = useState(0);
  const [selectDiscription, setSelectDiscription] = useState("");
  const [discription, setDiscription] = useState("");
  const [invoiceLink, setInvoiceLink] = useState("");
  const [allAccounts, setAllAccounts] = useState([]);
  const [account, setAccount] = useState("");
  const [isAccLoaded, setIsAccLoaded] = useState(true);
  const [allTypesOfSale] = useState([{ sale: "New" }, { sale: "Existing" }]);
  const [isReadOnly, setIsReadOnly] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [isLoaded, setIsLoaded] = useState(false);

  const linkUrl = window.location.origin;
  const user = useSelector((state) => state.user.data);
  let transactionId = param[0];
  let accessType = param[param.length - 1];
  const navigate = useNavigate();

  const getAllAccounts = async () => {
    if (accessType === "CREATE") {
      setIsAccLoaded(false);
      try {
        const res = await axios.get(`${url}/stripe/getAllAccounts`);
        if (res.data.success) {
          setAllAccounts(res.data.data);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setIsAccLoaded(true);
      }
    }
  };

  useEffect(() => {
    getAllAccounts();
  }, []);

  const submitForm = async () => {
    if (
      !name || !email || !number || !orderId || !typeOfSale ||
      !salesPerson || !amount || !discount || !additionalCharges ||
      !total || !selectDiscription || !discription || !account
    ) {
      setIsOpen(true);
      setMessage("Please fill all required fields.");
      setSeverity("error");
      return;
    }

    setIsLoaded(true);

    // ─── USA TIME ZONE ──────────────────────────────────────────
    const usaDateTime = getUSADateTime();
    const usaMonth = getUSAMonth();
    const usaYear = getUSAYear();

    const payload = {
      custName: name,
      custEmail: email,
      custContactNumber: number,
      brand: brandName,
      orderId,
      saleType: typeOfSale,
      salePerson: salesPerson,
      amount,
      discount,
      additionalCharges,
      total,
      discription: selectDiscription,
      detailDiscription: discription,
      year: usaYear,        // USA year
      month: usaMonth,      // USA month
      dateTime: usaDateTime, // USA date/time
      link: linkUrl,
      account,
    };

    try {
      const response = await axios.post(`${url}/transactions/addnew`, payload, {
        headers: { Authorization: `Bearer ${state.token}` },
      });
      if (response.data.success) {
        setIsOpen(true);
        setMessage("Invoice created successfully!");
        setSeverity("success");
        setTimeout(() => navigate("/transaction/list"), 2000);
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      setIsOpen(true);
      setMessage(error.message || "Something went wrong.");
      setSeverity("error");
    } finally {
      setIsLoaded(false);
    }
  };

  const getSpecificTransaction = async () => {
    if (accessType === "readOnly") {
      try {
        const res = await axios.post(`${url}/transactions/getSpecificTransaction`, {
          _id: transactionId,
        });
        if (res.data.success) {
          const ts = res.data.data[0];
          setIsReadOnly(true);
          setName(ts.custName);
          setEmail(ts.custEmail);
          setNumber(ts.custContactNumber);
          setBrandName(ts.brand);
          setOrderId(ts.orderId);
          setTypeOfSale(ts.saleType);
          setSalesPerson(ts.salePerson);
          setAmount(ts.amount);
          setDiscount(ts.discount);
          setAdditionalCharges(ts.additionalCharges);
          setTotal(ts.total);
          setSelectDiscription(ts.discription);
          setDiscription(ts.detailDiscription);
          setInvoiceLink(ts.invoiceLink);
          setAccount(ts.account);
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  useEffect(() => {
    getSpecificTransaction();
  }, []);

  return (
    <>
      <Navbar />
      <Container
        maxWidth={false}
        sx={{
          minHeight: "94vh",
          background: brand.gradient,
          py: 4,
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        {isAccLoaded ? (
          <Paper
            sx={{
              p: { xs: 2, md: 4 },
              maxWidth: "900px",
              width: "100%",
              borderRadius: "28px",
              boxShadow: "0 20px 60px rgba(0,6,223,0.12)",
              border: `1px solid ${brand.border}`,
            }}
          >
            <Typography
              variant="h4"
              align="center"
              sx={{
                color: brand.primary,
                fontWeight: 700,
                mb: 3,
                letterSpacing: "-0.5px",
              }}
            >
              {accessType === "CREATE" ? "Create Invoice" : "Invoice Details"}
            </Typography>

            {accessType === "readOnly" && (
              <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid item xs={12}>
                  <TextField
                    label="E‑ComSnaps Invoice Link"
                    fullWidth
                    disabled
                    value={invoiceLink}
                    InputProps={{
                      style: { color: brand.primary, fontWeight: 500 },
                    }}
                  />
                </Grid>
              </Grid>
            )}

            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Customer Name"
                  fullWidth
                  disabled={isReadOnly}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Customer Email"
                  fullWidth
                  disabled={isReadOnly}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Contact Number"
                  fullWidth
                  disabled={isReadOnly}
                  value={number}
                  onChange={(e) => setNumber(e.target.value)}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  label="Brand"
                  fullWidth
                  disabled
                  value="ecom"
                  InputProps={{
                    style: { color: brand.textPrimary, fontWeight: 500 },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  label="Order ID"
                  fullWidth
                  disabled={isReadOnly}
                  value={orderId}
                  onChange={(e) => setOrderId(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                  <InputLabel>Stripe Account</InputLabel>
                  <Select
                    value={account}
                    label="Stripe Account"
                    onChange={(e) => setAccount(e.target.value)}
                    disabled={isReadOnly || accessType === "readOnly"}
                  >
                    {accessType === "readOnly" ? (
                      <MenuItem value={account}>{account}</MenuItem>
                    ) : allAccounts.length > 0 ? (
                      allAccounts.map((acc) => (
                        <MenuItem key={acc.account} value={acc.account}>
                          {acc.account}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem value="">No accounts</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                  <InputLabel>Type of Sale</InputLabel>
                  <Select
                    value={typeOfSale}
                    label="Type of Sale"
                    onChange={(e) => setTypeOfSale(e.target.value)}
                    disabled={isReadOnly}
                  >
                    {accessType === "readOnly" ? (
                      <MenuItem value={typeOfSale}>{typeOfSale}</MenuItem>
                    ) : (
                      allTypesOfSale.map((item) => (
                        <MenuItem key={item.sale} value={item.sale}>
                          {item.sale}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Sales Person"
                  fullWidth
                  disabled={isReadOnly}
                  value={salesPerson}
                  onChange={(e) => setSalesPerson(e.target.value)}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  label="Amount"
                  type="number"
                  fullWidth
                  disabled={isReadOnly}
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label="Discount"
                  type="number"
                  fullWidth
                  disabled={isReadOnly}
                  value={discount}
                  onChange={(e) => setDiscount(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label="Additional Charges"
                  type="number"
                  fullWidth
                  disabled={isReadOnly}
                  value={additionalCharges}
                  onChange={(e) => setAdditionalCharges(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label="Total"
                  type="number"
                  fullWidth
                  disabled
                  value={total}
                />
              </Grid>

              <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                <Button
                  variant="outlined"
                  onClick={() => {
                    const calc = Number(amount) - Number(discount) + Number(additionalCharges);
                    setTotal(calc);
                  }}
                  disabled={isReadOnly}
                  sx={{
                    borderColor: brand.primary,
                    color: brand.primary,
                    borderRadius: "30px",
                    px: 4,
                    "&:hover": {
                      background: brand.primary,
                      color: brand.white,
                      borderColor: brand.primary,
                    },
                  }}
                >
                  Calculate Total
                </Button>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Service"
                  fullWidth
                  disabled={isReadOnly}
                  value={selectDiscription}
                  onChange={(e) => setSelectDiscription(e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Detailed Description"
                  multiline
                  rows={3}
                  fullWidth
                  disabled={isReadOnly}
                  value={discription}
                  onChange={(e) => setDiscription(e.target.value)}
                />
              </Grid>
            </Grid>

            <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 4, flexWrap: "wrap" }}>
              {accessType !== "readOnly" && (
                <Button
                  variant="contained"
                  onClick={submitForm}
                  disabled={isLoaded}
                  sx={{
                    background: brand.primary,
                    color: brand.white,
                    borderRadius: "30px",
                    px: 5,
                    py: 1.5,
                    fontWeight: 700,
                    "&:hover": { background: brand.primaryDark },
                    "&.Mui-disabled": { background: "#a0aec0" },
                  }}
                >
                  {isLoaded ? <CircularProgress size={24} sx={{ color: brand.white }} /> : "Generate Link"}
                </Button>
              )}
              <Button
                variant="outlined"
                onClick={() => navigate("/transaction/list")}
                sx={{
                  borderRadius: "30px",
                  px: 4,
                  borderColor: brand.primary,
                  color: brand.primary,
                  "&:hover": { background: brand.primary, color: brand.white },
                }}
              >
                Back
              </Button>
            </Box>
          </Paper>
        ) : (
          <CircularProgress sx={{ color: brand.primary }} />
        )}
      </Container>
      <CustomizedSnackbars isOpen={isOpen} severity={severity} message={message} />
    </>
  );
};

export default TransactionForm;